<template>
  <div>
    <top-header :type="6" :placeholder="'装修课堂详情'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem" />
    <div class="pad_top"></div>
    <div class="tab_con">
      <div class="middle bold">{{ obj.title }}</div>
      <div class="middle">发布时间：{{ obj.createTime }}</div>
      <div v-html="obj.content"></div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import topHeader from "@/components/header";
export default {
  name: 'classroomDetail',
  data() {
    return {
      id: this.$route.query.id,
      obj: {}
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.getInfo()
  },


  methods: {
    getInfo() {
      this.$request_again.post('/decoration/course/byId', qs.stringify({
        id: this.id
      }))
        .then(res => {
          this.obj = res.result
        })
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ img {
  width: 100%;
}

.pad_top {
  padding-top: 0.4rem;
}

.tab_con {

  .middle {
    text-align: center;
    font-size: 0.3rem;
  }

  .bold {
    font-size: 0.5rem;
    padding-bottom: 0.3rem;
    font-weight: 900;
  }

  // &>div:last-child {
  //   padding: 0.3rem;
  // }

  padding: 0 0.3rem 0 0.3rem;
}</style>